const UNIFORM_TYPES = {}
UNIFORM_TYPES[ 5126  /*FLOAT       */ ] = '1f';
UNIFORM_TYPES[ 35664 /*FLOAT_VEC2  */ ] = '2f';
UNIFORM_TYPES[ 35665 /*FLOAT_VEC3  */ ] = '3f';
UNIFORM_TYPES[ 35666 /*FLOAT_VEC4  */ ] = '4f';
UNIFORM_TYPES[ 35670 /*BOOL        */ ] =
UNIFORM_TYPES[ 5124  /*INT         */ ] =
UNIFORM_TYPES[ 35678 /*SAMPLER_2D  */ ] =
UNIFORM_TYPES[ 35680 /*SAMPLER_CUBE*/ ] = '1i';
UNIFORM_TYPES[ 35671 /*BOOL_VEC2   */ ] =
UNIFORM_TYPES[ 35667 /*INT_VEC2    */ ] = '2i';
UNIFORM_TYPES[ 35672 /*BOOL_VEC3   */ ] =
UNIFORM_TYPES[ 35668 /*INT_VEC3    */ ] = '3i';
UNIFORM_TYPES[ 35673 /*BOOL_VEC4   */ ] =
UNIFORM_TYPES[ 35669 /*INT_VEC4    */ ] = '4i';
UNIFORM_TYPES[ 35674 /*FLOAT_MAT2  */ ] = 'Matrix2f';
UNIFORM_TYPES[ 35675 /*FLOAT_MAT3  */ ] = 'Matrix3f';
UNIFORM_TYPES[ 35676 /*FLOAT_MAT4  */ ] = 'Matrix4f';

export default UNIFORM_TYPES;